'use client';

import { Button, Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';

interface CouponDownloadAllButtonProps {
  availableCount: number;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export const CouponDownloadAllButton = ({
  availableCount,
  onClick,
  disabled = false,
  className,
}: CouponDownloadAllButtonProps) => {
  const buttonText =
    availableCount > 0 ? `쿠폰 전체받기 (${availableCount}장)` : '발급 가능 쿠폰 없음';

  return (
    <div
      className={twMerge(
        'fixed bottom-0 z-20 w-full max-w-[600px] border-t border-gray-200 bg-white px-4 py-3',
        className,
      )}
      style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 12px)' }}
    >
      <Button
        variant="primary"
        className="w-full"
        disabled={disabled || availableCount === 0}
        onClick={onClick}
      >
        <Typography variant="body14pxMed" colorScheme={availableCount === 0 ? 'gray-400' : 'white'}>
          {buttonText}
        </Typography>
      </Button>
    </div>
  );
};
